const getDynamicDataTestId = ({
  dataTestId,
  atomElemnt,
}: {
  dataTestId: string;
  atomElemnt: string;
}): string | undefined =>
  dataTestId ? `${atomElemnt}_${dataTestId}` : undefined;

export default getDynamicDataTestId;
